// LUMINA · pages/vajra/admin/TopicHubSection.jsx
// Phase 68+73: Staff CRUD for TopicHub + group_key

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, TXT2, PANEL } from '../constants';

const EMPTY = {
  slug:"", title_zh:"", title_en:"", subtitle_zh:"", subtitle_en:"",
  description_zh:"", description_en:"", cover_image_url:"", tradition:"",
  teacher_name_zh:"", teacher_name_en:"", teacher_id:"",
  is_active:true, is_featured:false, sort_order:0,
  group_key:"", group_label_zh:"", group_label_en:"",
};
const lbl = { fontSize:11, color:TXT2, marginBottom:3, display:"block" };
const inp = { width:"100%", padding:"6px 9px", borderRadius:6, border:"1px solid rgba(0,0,0,0.12)", fontSize:12, boxSizing:"border-box", background:"#fff", marginBottom:8 };

export default function TopicHubSection({ token, headers, teacherList=[] }) {
  const [hubs,     setHubs]     = useState([]);
  const [form,     setForm]     = useState(EMPTY);
  const [editId,   setEditId]   = useState(null);
  const [msg,      setMsg]      = useState("");
  const [showForm, setShowForm] = useState(false);
  const [uploadingImg, setUploadingImg] = useState(false);

  const handleCoverUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { setMsg("✗ 图片过大（最大10MB）"); return; }
    setUploadingImg(true);
    const fd = new FormData();
    fd.append('file', file);
    const uploadHeaders = { Authorization: headers.Authorization };
    try {
      const r = await fetch(`${API}/vajra/staff/upload`, { method:'POST', headers: uploadHeaders, body: fd });
      const d = await r.json();
      if (r.ok) { setForm(f => ({ ...f, cover_image_url: d.url })); setMsg("✓ 封面上传成功"); }
      else setMsg("✗ " + (d.detail || "上传失败"));
    } catch { setMsg("✗ 上传失败"); }
    setUploadingImg(false);
  };

  const load = useCallback(async () => {
    const r = await fetch(`${API}/vajra/staff/topic-hubs`, { headers }).catch(() => null);
    if (r?.ok) setHubs(await r.json());
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  const openNew = () => { setForm(EMPTY); setEditId(null); setShowForm(true); setMsg(""); };
  const openEdit = h => {
    setForm({
      slug: h.slug||"", title_zh: h.title_zh||"", title_en: h.title_en||"",
      subtitle_zh: h.subtitle_zh||"", subtitle_en: h.subtitle_en||"",
      description_zh: h.description_zh||"", description_en: h.description_en||"",
      cover_image_url: h.cover_image_url||"", tradition: h.tradition||"",
      teacher_name_zh: h.teacher_name_zh||"", teacher_name_en: h.teacher_name_en||"",
      teacher_id: h.teacher_id||"", is_active: h.is_active!==false,
      is_featured: !!h.is_featured, sort_order: h.sort_order||0,
      group_key: h.group_key||"", group_label_zh: h.group_label_zh||"", group_label_en: h.group_label_en||"",
    });
    setEditId(h.id); setShowForm(true); setMsg("");
  };

  const submit = async e => {
    e.preventDefault();
    const payload = {
      ...form,
      teacher_id:  form.teacher_id  ? parseInt(form.teacher_id)  : null,
      sort_order:  form.sort_order  ? parseInt(form.sort_order)   : 0,
      group_key:   form.group_key   || null,
    };
    const url    = editId ? `${API}/vajra/staff/topic-hubs/${editId}` : `${API}/vajra/staff/topic-hubs`;
    const method = editId ? "PUT" : "POST";
    const r = await fetch(url, { method, headers, body: JSON.stringify(payload) });
    if (r.ok) {
      setMsg(editId ? "✓ 专题已更新" : "✓ 专题已创建");
      setShowForm(false); setEditId(null); setForm(EMPTY); load();
    } else {
      const d = await r.json();
      setMsg("✗ " + (d.detail || "操作失败"));
    }
  };

  const deactivate = async id => {
    if (!window.confirm("确认停用此专题？")) return;
    const r = await fetch(`${API}/vajra/staff/topic-hubs/${id}`, { method:"DELETE", headers });
    if (r.ok) { setMsg("✓ 已停用"); load(); } else setMsg("✗ 操作失败");
  };

  return (
    <div style={{background:PANEL,borderRadius:12,padding:20,border:"1px solid rgba(0,0,0,0.06)"}}>
      <div style={{fontSize:14,color:GD,marginBottom:4}}>专题管理</div>
      <div style={{fontSize:11,color:"#aaa",marginBottom:16}}>每个传承/本尊一个专题页面，汇集相关法会、法教与法宝。可设置分组归类。</div>
      {msg && <div style={{fontSize:13,padding:"8px 12px",borderRadius:8,marginBottom:12,
                background:msg.startsWith("✗")?"rgba(220,38,38,0.08)":"rgba(5,150,105,0.08)",
                color:msg.startsWith("✗")?"#dc2626":"#059669"}}>{msg}</div>}

      <button onClick={openNew} style={{padding:"6px 14px",background:GD,color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontSize:12,marginBottom:16}}>
        + 新建专题
      </button>

      {showForm && (
        <form onSubmit={submit} style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20,padding:"14px 16px",background:"rgba(212,175,55,0.04)",borderRadius:10,border:"1px solid rgba(212,175,55,0.15)"}}>
          <div style={{gridColumn:"1/-1",fontSize:12,color:GD,fontWeight:600,marginBottom:4}}>{editId?"编辑专题":"新建专题"}</div>
          <div>
            <label style={lbl}>Slug（唯一标识）*</label>
            <input value={form.slug} onChange={e=>setForm({...form,slug:e.target.value})} required placeholder="vajrakilaya" style={inp}/>
          </div>
          <div>
            <label style={lbl}>专题名称（中文）*</label>
            <input value={form.title_zh} onChange={e=>setForm({...form,title_zh:e.target.value})} required placeholder="普巴金刚" style={inp}/>
          </div>
          <div>
            <label style={lbl}>专题名称（英文）</label>
            <input value={form.title_en||""} onChange={e=>setForm({...form,title_en:e.target.value})} placeholder="Vajrakilaya" style={inp}/>
          </div>
          <div>
            <label style={lbl}>副标题（中文）</label>
            <input value={form.subtitle_zh||""} onChange={e=>setForm({...form,subtitle_zh:e.target.value})} style={inp}/>
          </div>

          {/* Phase 73: Group fields */}
          <div style={{gridColumn:"1/-1",fontSize:11,color:GD,fontWeight:600,marginTop:4,marginBottom:-2}}>分组归类（将多个专题归为一组）</div>
          <div>
            <label style={lbl}>分组 Key*</label>
            <input value={form.group_key||""} onChange={e=>setForm({...form,group_key:e.target.value})} placeholder="deity / dzogchen / naropa" style={inp}/>
          </div>
          <div>
            <label style={lbl}>分组中文名</label>
            <input value={form.group_label_zh||""} onChange={e=>setForm({...form,group_label_zh:e.target.value})} placeholder="本尊法" style={inp}/>
          </div>

          <div>
            <label style={lbl}>传承</label>
            <input value={form.tradition||""} onChange={e=>setForm({...form,tradition:e.target.value})} placeholder="宁玛派" style={inp}/>
          </div>
          <div>
            <label style={lbl}>核心上师（中文）</label>
            <input value={form.teacher_name_zh||""} onChange={e=>setForm({...form,teacher_name_zh:e.target.value})} style={inp}/>
          </div>
          <div>
            <label style={lbl}>关联上师记录</label>
            <select value={form.teacher_id||""} onChange={e=>setForm({...form,teacher_id:e.target.value})} style={inp}>
              <option value="">— 无 —</option>
              {teacherList.map(t=><option key={t.id} value={t.id}>{t.name_zh}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>封面图URL</label>
            <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:8}}>
              <input value={form.cover_image_url||""} onChange={e=>setForm({...form,cover_image_url:e.target.value})} placeholder="https://... 或点右侧上传" style={{...inp,flex:1,marginBottom:0}}/>
              <label style={{fontSize:11,color:GD,cursor:uploadingImg?"wait":"pointer",padding:"6px 10px",borderRadius:7,border:"1px dashed rgba(139,105,20,0.4)",background:"rgba(139,105,20,0.04)",whiteSpace:"nowrap",flexShrink:0,opacity:uploadingImg?0.5:1}}>
                {uploadingImg?"⏳":"🖼 上传"}
                <input type="file" accept="image/*" onChange={handleCoverUpload} style={{display:"none"}} disabled={uploadingImg}/>
              </label>
            </div>
          </div>
          <div style={{gridColumn:"1/-1"}}>
            <label style={lbl}>简介（中文）</label>
            <textarea value={form.description_zh||""} onChange={e=>setForm({...form,description_zh:e.target.value})} rows={3} style={{...inp,resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",gap:16,alignItems:"center"}}>
            <label style={{fontSize:12,display:"flex",gap:6,alignItems:"center",cursor:"pointer"}}>
              <input type="checkbox" checked={!!form.is_featured} onChange={e=>setForm({...form,is_featured:e.target.checked})}/> 首页推荐
            </label>
            <label style={{fontSize:12,display:"flex",gap:6,alignItems:"center",cursor:"pointer"}}>
              <input type="checkbox" checked={form.is_active!==false} onChange={e=>setForm({...form,is_active:e.target.checked})}/> 启用
            </label>
          </div>
          <div>
            <label style={lbl}>排序（数字越小越靠前）</label>
            <input type="number" value={form.sort_order||0} onChange={e=>setForm({...form,sort_order:e.target.value})} style={{...inp,width:80}}/>
          </div>
          <div style={{gridColumn:"1/-1",display:"flex",gap:10}}>
            <button type="submit" style={{padding:"7px 16px",background:GD,color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontSize:12}}>
              {editId?"保存修改":"创建专题"}
            </button>
            <button type="button" onClick={()=>{setShowForm(false);setEditId(null);setForm(EMPTY);}} style={{padding:"7px 16px",background:"rgba(0,0,0,0.06)",color:"#555",border:"none",borderRadius:7,cursor:"pointer",fontSize:12}}>
              取消
            </button>
          </div>
        </form>
      )}

      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {hubs.map(h => (
          <div key={h.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",background:"#fff",borderRadius:8,border:"1px solid rgba(0,0,0,0.07)"}}>
            <div>
              <span style={{fontSize:13,color:"rgba(0,0,0,0.75)",fontWeight:500}}>{h.title_zh}</span>
              <span style={{fontSize:11,color:"#aaa",marginLeft:8}}>{h.slug}</span>
              {h.group_key && <span style={{fontSize:10,color:"#3b82f6",marginLeft:6,background:"rgba(59,130,246,0.08)",borderRadius:4,padding:"1px 6px"}}>{h.group_label_zh || h.group_key}</span>}
              {h.tradition && <span style={{fontSize:10,color:"#aaa",marginLeft:6}}>· {h.tradition}</span>}
              {h.is_featured && <span style={{fontSize:10,color:GD,marginLeft:6}}>★ 推荐</span>}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>openEdit(h)} style={{padding:"4px 10px",background:"rgba(212,175,55,0.10)",color:GD,border:"1px solid rgba(212,175,55,0.30)",borderRadius:5,cursor:"pointer",fontSize:11}}>编辑</button>
              <button onClick={()=>deactivate(h.id)} style={{padding:"4px 10px",background:"rgba(220,38,38,0.06)",color:"#dc2626",border:"1px solid rgba(220,38,38,0.20)",borderRadius:5,cursor:"pointer",fontSize:11}}>停用</button>
            </div>
          </div>
        ))}
        {hubs.length === 0 && <div style={{fontSize:12,color:"#ccc",padding:8}}>暂无专题，点击「新建专题」开始。</div>}
      </div>
    </div>
  );
}
